// eslint-disable-next-line import/extensions
import('./bootstrap.js');
